/**
 * Die Funde eines Gateways, nach ihrem Zustand getrennt (HM-117).
 *
 * **Hier und nicht in der Komponente**, weil die Trennung an zwei Stellen
 * gebraucht wird und dort verschieden viel davon erscheint: Die Seite des
 * Gateways zeigt alle drei Gruppen, die Geräteverwaltung nur die offenen. Zwei
 * Fassungen derselben Filterzeile liefen beim nächsten Zustand auseinander —
 * dieselbe Überlegung wie bei `statTiles` und `deviceHints`.
 *
 * **Gelesen wird nur der Zustand**, und der Typ sagt das auch: Die Funktion
 * ordnet Zeilen, sie deutet sie nicht.
 */
import type { ApiComponents } from "@hausmeter/sdk";

type GatewayNodeStatus = ApiComponents["schemas"]["GatewayNode"]["status"];

export type GatewayNodeGroups<T> = {
  /** Gefunden und noch nicht entschieden — das, was eine Handlung verlangt. */
  readonly pending: readonly T[];
  readonly allowed: readonly T[];
  readonly dismissed: readonly T[];
};

export function gatewayNodeGroups<T extends { readonly status: GatewayNodeStatus }>(
  nodes: readonly T[],
): GatewayNodeGroups<T> {
  return {
    pending: nodes.filter((node) => node.status === "pending"),
    allowed: nodes.filter((node) => node.status === "allowed"),
    dismissed: nodes.filter((node) => node.status === "dismissed"),
  };
}
